import React, { FC } from "react";

import { HoverListPreview } from "../hover/HoverListPreview";
import { AvatarPlaceholder } from "./AvatarPlaceholder";

export type AvatarStackItem = {
  id: string;
  label: string;
  name: string;
  color?: string;
};

type Props = {
  items: AvatarStackItem[];
  maxVisible?: number;
  withPreview?: boolean;
  previewTitle?: string;
  isPreviewDisabled?: boolean;
};

const VISIBLE_AVATAR_OFFSET = "0px";
const FALLBACK_AVATAR_LABEL = "N/A";

export const AvatarStack: FC<Props> = ({
  items,
  maxVisible = 3,
  withPreview,
  previewTitle = "Items:",
  isPreviewDisabled,
}) => {
  const visibleItems = items.slice(0, maxVisible);
  const hiddenItemsCount = Math.max(items.length - visibleItems.length, 0);
  const shouldShowFallback = items.length === 0;
  const previewContent = items.map((item) => (
    <div className={"flex items-center space-x-[4px] px-4 py-1"} key={item.id}>
      <AvatarPlaceholder
        size={"2xs"}
        type={"custom"}
        avatarCustomColor={item.color}
        label={item.label}
      />
      <div className={"font-medium"}>{item.name}</div>
    </div>
  ));

  return (
    <HoverListPreview
      title={previewTitle}
      content={previewContent}
      isDisabled={!withPreview || isPreviewDisabled || items.length === 0}>
      <div className={"flex items-center"}>
        {shouldShowFallback && (
          <AvatarPlaceholder
            size={"2xs"}
            type={"custom"}
            label={FALLBACK_AVATAR_LABEL}
          />
        )}

        {visibleItems.map((item) => (
          <AvatarPlaceholder
            key={item.id}
            size={"2xs"}
            type={"custom"}
            avatarCustomColor={item.color}
            label={item.label}
          />
        ))}

        {hiddenItemsCount > 0 && (
          <div
            className={
              "flex h-6 w-6 items-center justify-center rounded-full border border-[#2B333C66] bg-white text-xs font-semibold text-[#2B333C]"
            }
            style={{ marginLeft: VISIBLE_AVATAR_OFFSET }}>
            +{hiddenItemsCount}
          </div>
        )}
      </div>
    </HoverListPreview>
  );
};
